export default "/images/Open.svg?8d63fec82c5b36108d3229d8764411f5";